// ask_view — PUR. La question telle que le SERVEUR la tient (platform-service/lib/ask_pending),
// lue par la console.
//
// LE SERVEUR FAIT FOI. Les agents posent leurs questions dans le flux du run, mais deux voies
// peuvent demander dans le même run, et la console gardait la DERNIÈRE vue — celle-là même qui
// écrasait l'autre côté serveur (design_questions_operateur.md). Le serveur tient maintenant une
// FILE ; la console affiche sa tête, avec son identité (`id`, que le clic renvoie pour répondre à
// CETTE question) et ce qui suit (`remaining`).

export type AskView = {
  question:    string;
  options:     readonly string[];
  multiSelect: boolean;
  /** L'identité serveur de la question — absente pour la revue des parcours et un serveur d'avant la file. */
  id?:         string;
  /** Combien de questions attendent après celle-ci. */
  remaining?:  number;
};

/** La question rendue par le serveur, ou null quand il n'y en a pas de lisible. */
export function askViewFromServer(raw: unknown): AskView | null {
  if (typeof raw !== "object" || raw === null) return null;
  const r = raw as Record<string, unknown>;
  if (!Array.isArray(r.options)) return null;
  const options = r.options.filter((o): o is string => typeof o === "string" && o.length > 0);
  if (options.length < 2) return null;
  return {
    question: typeof r.question === "string" ? r.question : "",
    options,
    multiSelect: r.multiSelect === true,
    ...(typeof r.id === "string" && r.id !== "" ? { id: r.id } : {}),
    ...(typeof r.remaining === "number" && Number.isInteger(r.remaining) && r.remaining > 0 ? { remaining: r.remaining } : {}),
  };
}
